<template>
  <div class="formation">
    <span class="text-h4">{{ $t('formation.formation') }}</span>
    <div
      v-if="readOnly"
    >
      <span class="text-h4">{{ modelValue }}</span>
    </div>
    <div
      v-else
      class="title-info"
    >
      <v-select
        :modelValue="modelValue"
        :items="formationItems"
        outlined
        dense
        hide-details
        color="white"
        bg-color="rgb(62, 68, 86)"
        item-color="white"
        menu-icon="fa-caret-down"
        density="compact"
        @update:modelValue="$emit('update:modelValue', $event)"
        :list-props="{ bgColor: 'rgb(62, 68, 86)' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Formation',
  props: {
    modelValue: {
      type: String,
      default: '4-4-2',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formationItems: this.$consts.MEGA_LEAGUE.FORMATION,
    };
  },
};
</script>

<style scoped lang="scss">
.formation {
  display: flex;
  flex-direction: column;
  .text-h4 {
    text-align: end;
  }
}

.title-info {
  display: flex;
  background-color: #3b425c;
  border-radius: 4px;
}

@media (max-width:500px){
  .formation{
    .text-h4{
      display: flex;
      justify-self: center;
    }
  }
}
</style>
